import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { computed } from "vue";
import { useTenantConfig } from "../composables/useTenantConfig";


export default /*#__PURE__*/_defineComponent({
  __name: 'DichiarazioneAccessibilita',
  setup(__props) {

const { getDichiarazioneAccessibilita } = useTenantConfig();

const dichiarazioneAccessibilitaText = computed(() => {
    if (getDichiarazioneAccessibilita.value && getDichiarazioneAccessibilita.value.some((item) => item.varName == "presavisioneaccessibilita.modaltext")) {
        return getDichiarazioneAccessibilita.value.find((item) => item.varName == "presavisioneaccessibilita.modaltext")?.value;
    }

    return "Nessun testo definito per la dichiarazione di accessibilità";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", { innerHTML: dichiarazioneAccessibilitaText.value }, null, 8, _hoisted_1))
}
}

})